import initCommon from './application.js'
import initSwiper from './initializers/Swiper.js'
import initTravelInfoAccordion from './initializers/TravelInfoAccordion.js'
import initVenueAccordion from './initializers/VenueAccordion.js'
import initYoutubePlayer from './initializers/YoutubePlayer.js'

const initStatic = () => {
  initCommon()
  initSwiper()
  initTravelInfoAccordion()
  initVenueAccordion()
  initYoutubePlayer()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStatic)
} else {
  initStatic()
}
